/**
 * Methode utils pour les gestions de fichiers / binaires
 */
export class WizFileUtils {

  /**
   * formatBytes
   * converti des byte en KB/MB pour rendu "textuel"
   * @param bytes nb octets
   */
  public static formatBytes(bytes: number): string {
    const def = [[1, 'octets'], [1024, 'ko'], [1024 * 1024, 'Mo'], [1024 * 1024 * 1024, 'Go'], [1024 * 1024 * 1024 * 1024, 'To']];

    let response: string;
    def.find((item, index) => {
      const defValue = item[0] as number;
      if (bytes < defValue) {
        // récupére le précédent item pour avoir 70ko plutot que 0.07Mo
        const previousValue: number = def[index - 1 ][0] as number;
        return response = Math.round(bytes / previousValue) + ' ' + def[index - 1][1];
      }
    });
    return response;
  }

  /**
   * Get extension file
   * @param file: File
   * @return string
   */
  public static getExtension(file: File): null|string {
    if (file.name.indexOf('.') === -1) {
      return null;
    }
    return file.name.split('.').pop();
  }

  /**
   * retourne le code Mime pour un base64
   */
  public static detectImageMimeType(base64: string): string | null {
    // Dictionnaire signatures Base64 → type MIME
    const signatures: { [prefix: string]: string } = {
      // PNG
      "iVBORw0KGgo": "image/png",

      // JPEG
      "/9j/": "image/jpeg",

      // GIF
      "R0lGODdh": "image/gif",
      "R0lGODlh": "image/gif",

      // WEBP - RIFF + WEBP
      "UklGR": "image/webp",

      // AVIF signatures
      "AAAAIGZ0eXBhdmlm": "image/avif",
      "GZ0eXBhdmlm": "image/avif",
      "GZ0eXBtaWYx": "image/avif",

      // SVG (XML text)
      "PHN2Zw": "image/svg+xml", // <svg
      "PD94bW": "image/svg+xml", // <?xml

      // BMP
      "Qk": "image/bmp",

      // TIFF
      "SUkq": "image/tiff", // little-endian
      "TU0K": "image/tiff", // big-endian

      // ICO
      "AAABAA": "image/x-icon"
    };

    // Parcours des signatures
    for (const prefix in signatures) {
      if (base64.startsWith(prefix)) {
        return signatures[prefix];
        //return `data:${signatures[prefix]};base64,${base64}`;
      }
    }

    return null; // type inconnu
  }


  /** retourne un format image depuis le string en paramètre, ou le média par défaut */
  public static imageFromBinaryString(source?:string, alternate? :any) :any {
    let result : any = null;
    if(source && source.length >0 ) {
        if(source.startsWith('data')) { // déjà image
          return source;
        }

        let try64: string = this.detectImageMimeType(source);
        if(!!try64) { // c'est déjà du base64 (attention, juste les PNG, il faut les autres types)
          result = `data:${try64};base64,${source}`;
        } else {
          try {
            result = 'data:image/png;base64,' + atob(source);
          } catch(e:any) {
            console.log('imageFromBinaryString err', e);
          }
          
        }
    } else if (alternate) {
      result = alternate;
    }
    return result;
  }

  /**
   * conversion base64 en byteString pour appels de services (IA)
   * @param base64 
   * @returns Uint8Array
   */
  public static base64ToByteArray(base64: string): Uint8Array {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    return bytes;
  }

  /**
   * joli JSON pour les zones de commentaires
   * @param obj 
   * @returns 
   */
  public static jsonToPrettyText(obj: Record<string, any>): string {
    return Object.entries(obj)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');
  }

}
